const regionDisplayOptions = [
  { value: 'state', label: 'States' },
  { value: 'metro', label: 'States + Metro Areas' },
]

export default regionDisplayOptions
